import React from "react";
import {
  RESOURCES,
  Services,
  Company,
  Industries,
} from "components/layout/footer/FooterData";
import LogoSvg from "assets/svg/logo";
import { Link } from "gatsby";
import OptimizedImage from "hooks/OptimizedImage";

export default function FooterNavigation() {
  return (
    <footer>
      <div className=" pt-24 bg-basecol text-gray px-10 md:pl-10 xl:pl-0">
        <div className="max-w-7xl p-4 mx-auto">
          <div className="lg:flex md:p-0 sm:px-7 sm:pt-7">
            <div className="font-opensans mb-10 lg:mb-0 md:mb-0 md:mr-10 w-full lg:w-1/4">
              <div className="flex pb-12 items-center">
                <a href="https://www.tomedes.com/">
                  <LogoSvg />
                </a>
              </div>
              <div className="flex flex-col justify-between relative h-full ">
                <div className="flex flex-col items-center justify-center">
                  <h3 className="text-sm font-opensans font-normal leading-7 text-footertext">
                    Tomedes Translation Services is committed to broadening the
                    horizons of individuals and businesses in the United States
                    and internationally, through the effective use of
                    professional translation services.{" "}
                  </h3>
                  <h3 className="text-sm font-opensans font-normal leading-7 text-footertext mt-8">
                    Our translation company provides fast and accurate
                    translation services in more than 120 languages and 950+
                    language pairs and is available 24/7 via email, phone or
                    chat.
                  </h3>
                </div>
              </div>
            </div>
            <div className="flex justify-center gap-5 my-10 lg:hidden">
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/certificates/ISO_9001.webp"
                alt="ISO9001"
                className="w-20 sm:w-28 h-auto"
              />
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/certificates/ISO_17100.webp"
                alt="ISO17100"
                className="w-20 sm:w-28 h-auto"
              />
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/certificates/ISO_18587.webp"
                alt="ISO18587"
                className="w-20 sm:w-28 h-auto"
              />
            </div>
            <div className="flex-1 ">
              <div className="md:flex md:justify-between gap-4 md:mt-7 ">
                <div className="mb-10 lg:mb-24 md:pl-7 xl:ml-7">
                  <div className="font-opensans xs:font-secondary pb-10 lg:pb-12 text-lg font-semibold text-white uppercase">
                    <Link
                      to="/translation-services"
                      className="hover:text-orange transition-colors duration-300"
                    >
                      Translation Services
                    </Link>
                  </div>
                  <ul className="font-opensans text-sm cursor-pointer">
                    {Services?.map(({ data, link }, index) => (
                      <li
                        key={index}
                        className=" text-footertext hover:text-hover pb-2 leading-[30px] font-opensans"
                      >
                        <Link to={link}>{data}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mb-10 lg:mb-24 md:pl-7">
                  <div className="font-opensans xs:font-secondary pb-10 lg:pb-12 text-lg font-semibold text-white uppercase">
                    <Link
                      to="/industries"
                      className="hover:text-orange transition-colors duration-300"
                    >
                      Industries
                    </Link>
                  </div>
                  <ul className="font-opensans text-sm cursor-pointer ">
                    {Industries?.map(({ data, link }, index) => (
                      <li
                        key={index}
                        className=" text-footertext hover:text-hover pb-2 leading-[30px] font-opensans"
                      >
                        <Link to={link}>{data}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mb-10 lg:mb-24 lg:pl-7">
                  <div className="font-opensans xs:font-secondary pb-10 lg:pb-12 text-lg font-semibold text-white uppercase">
                    TESTIMONIALS
                  </div>
                  <ul className="font-opensans text-sm cursor-pointer">
                    {Company?.map(({ data, link, imgUrl }, index) => (
                      <li
                        key={index}
                        className=" text-footertext hover:text-hover pb-2 leading-[30px] font-opensans"
                      >
                        <a href={link} target="_blank" className="flex gap-4">
                          <img src={imgUrl} alt="" />
                          {data}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <ul className="justify-between relative lg:flex item-center md:grid gap-y-8 grid-cols-2 hidden lg:-mt-[30px] mt-3 mb-8 lg:px-0 px-[25px]">
            <li className="justify-self-end text-footertext hover:text-hover pb-2 leading-[30px] font-opensans ">
              <Link to="/tools">Tools</Link>
            </li>
            <li className="justify-self-end text-footertext hover:text-hover pb-2 leading-[30px] font-opensans     ">
              <Link to="/tools/text-summarizer">Summary Generator</Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans   ">
              <Link to="/tools/language-detector">Detect Language</Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans ">
              <Link to="/tools/translation-quality-assurance">
                Translation Quality Assurance Tool
              </Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans ">
              <Link to="/tools/translation-difficulty-checker">
                Translation Difficulty Checker
              </Link>
            </li>
            <li className=" justify-self-end text-footertext hover:text-hover pb-4 leading-[30px] font-opensans ">
              <Link to="/tools/word-count-ratio">Word Count Ratio Tool</Link>
            </li>{" "}
          </ul> */}
          {/* <ul className="max-w-6xl mx-auto justify-between relative lg:flex item-center md:grid gap-y-8 grid-cols-2 hidden lg:-mt-[30px] mt-3 mb-8 lg:px-0 px-[25px]">
            <li className="justify-self-end text-footertext hover:text-hover pb-2 leading-[30px] font-opensans     ">
              <Link to="/tools/glossary-generator">Glossary Generator</Link>
            </li>
            <li className="justify-self-end text-footertext hover:text-hover pb-2 leading-[30px] font-opensans     ">
              <Link to="/tools/topic-detection">Topic Detection Tool</Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans   ">
              <Link to="/tools/data-anonymization">
                Data Anonymization Tool{" "}
              </Link>
            </li>
            <li className="justify-self-end text-footertext hover:text-hover pb-2 leading-[30px] font-opensans     ">
              <Link to="/tools/translation-consistency-checker">
                Consistency Checker
              </Link>
            </li>
            <li className="justify-self-end text-footertext hover:text-hover pb-2 leading-[30px] font-opensans ">
              <Link to="/careers">Careers</Link>
            </li>
            <li className=" justify-self-end text-footertext hover:text-hover pb-4 leading-[30px] font-opensans ">
              <Link to="/resources/videos">Videos</Link>
            </li>{" "}
          </ul> */}

          {/* <ul className="md:hidden font-opensans text-sm cursor-pointer">
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans">
              <Link to="/tools">Tools</Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans">
              <Link to="/tools/text-summarizer">Summary Generator</Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans">
              <Link to="/tools/language-detector">Detect Language</Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans">
              <Link to="/tools/language-detector">Language Detection Tool</Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans">
              <Link to="/tools/translation-quality-assurance">
                Translation Quality Assurance Tool
              </Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans">
              <Link to="/tools/translation-difficulty-checker">
                Translation Difficulty Checker
              </Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans">
              <Link to="/tools/word-count-ratio">Word Count Ratio Tool</Link>
            </li>
          </ul>
          <ul className="md:hidden font-opensans text-sm cursor-pointer">
            <li className="justify-self-end text-footertext hover:text-hover pb-2 leading-[30px] font-opensans     ">
              <Link to="/tools/topic-detection">Topic Detection Tool</Link>
            </li>
            <li className="text-footertext hover:text-hover pb-2 leading-[30px] font-opensans   ">
              <Link to="/tools/data-anonymization">
                Data Anonymization Tool
              </Link>
            </li>
            <li className="justify-self-end text-footertext hover:text-hover pb-2 leading-[30px] font-opensans     ">
              <Link to="/tools/glossary-generator">Glossary Generator</Link>
            </li>
            <li className="justify-self-end text-footertext hover:text-hover pb-2 leading-[30px] font-opensans     ">
              <Link to="/tools/translation-consistency-checker">
                Consistency Checker
              </Link>
            </li>
            <li className="justify-self-end text-footertext hover:text-hover pb-2 leading-[30px] font-opensans ">
              <Link to="/careers">Careers</Link>
            </li>
            <li className=" justify-self-end text-footertext hover:text-hover pb-4 leading-[30px] font-opensans ">
              <Link to="/resources/videos">Videos</Link>
            </li>{" "}
          </ul> */}
        </div>
      </div>
    </footer>
  );
}
